import { useEffect, useState } from 'react';
import { isEmpty } from '@rainbow-modules/validation';
import { useReduxForm } from '@rainbow-modules/hooks';
import { JsonInput } from '@rainbow-modules/forms';
import { Value } from '@rainbow-modules/forms/lib/components/JsonInput/types';
import { Customer } from 'data/firestore/agent/customer/types';
import CreateUpdateLLMTestInputModal from './CreateUpdateLLMTestInputModal';
import LLMTestJsonInputActions from './actions';
import { Container } from './styled';
import { LLMTestJsonInputProps } from './types';
import useManageLLMTestInputs from './hooks/useManageLLMTestInputs';

const ADD_EDIT_LLM_TEST_INPUT_MODAL_PREFIX = 'add-edit-llm-test-input';

const isEmptyValue = (value?: Value) => {
    if (typeof value === 'string') {
        return isEmpty(value) || isEmpty(JSON.parse(value || '{}'));
    }
    return isEmpty(value);
};

const LLMTestJsonInput = (props: LLMTestJsonInputProps) => {
    const {
        id,
        className,
        agentId,
        featureSchema,
        inputSchema,
        customer,
        name,
        value,
        onChange = () => {},
        ...rest
    } = useReduxForm(props);
    const [customerValue, setCustomerValue] = useState<Customer | undefined>(customer);

    const modalId = `${ADD_EDIT_LLM_TEST_INPUT_MODAL_PREFIX}__${name}`;

    const { save, remove, generate } = useManageLLMTestInputs({
        modalId,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        onInputGenerated: (input: Record<string, unknown>) => onChange(input),
    });

    const jsonString = typeof value === 'string' ? value : JSON.stringify(value);

    const handleSelectStoredInput = (inputContent: string) => {
        onChange(JSON.parse(inputContent));
        if (customerValue?.id) {
            generate({
                inputSchema: inputSchema || {},
                customer: customerValue as unknown as Record<string, unknown>,
                input: JSON.parse(inputContent),
            });
        }
    };

    const handleRequestGenerateInputData = () => generate({
        inputSchema: inputSchema || {},
        customer: customer as unknown as Record<string, unknown>,
    });

    useEffect(() => {
        if (!isEmptyValue(value) && !isEmpty(customer) && customerValue?.id !== customer?.id) {
            generate({
                inputSchema: inputSchema || {},
                customer: customer as unknown as Record<string, unknown>,
                input: typeof value === 'string' ? JSON.parse(value) : value,
            });
        }
        setCustomerValue(customer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customer]);

    return (
        <>
            <Container id={id} className={className}>
                <JsonInput {...rest} value={value} onChange={onChange} />
                <LLMTestJsonInputActions
                    agentId={agentId}
                    currentInputValue={jsonString}
                    onSelect={handleSelectStoredInput}
                    onSave={save}
                    onDelete={remove}
                    onRequestGenerate={handleRequestGenerateInputData}
                />
            </Container>
            <CreateUpdateLLMTestInputModal modalId={modalId} />
        </>
    );
};

export default LLMTestJsonInput;
